import { FaMobileAlt, FaChartBar, FaHeadset } from "react-icons/fa";
import { Section, StatsGrid, StatCard } from "./style";

const stats = [
	{
		icon: FaMobileAlt,
		value: "100%",
		label: "Responsivo e acessível em qualquer dispositivo.",
	},
	{
		icon: FaChartBar,
		value: "24/7",
		label: "Plataforma disponível a qualquer hora do dia.",
	},
	{
		icon: FaHeadset,
		value: "Suporte",
		label: "Equipe dedicada para ajudar você sempre que precisar.",
	},
];

export function StatsSection() {
	return (
		<Section>
			<div className="container">
				<StatsGrid>
					{stats.map((stat) => {
						const Icon = stat.icon;
						return (
							<StatCard key={stat.label}>
								<Icon size={28} className="icon" />
								<span className="value">{stat.value}</span>
								<p>{stat.label}</p>
							</StatCard>
						);
					})}
				</StatsGrid>
			</div>
		</Section>
	);
}
